import { DataPoint, DataPointTreeItem } from 'src/pages/SignInPage/_BLL/types';
import { db } from '../init';

export const addDataPointTreeBoolean = async (dataPointTree: DataPointTreeItem[]) => {
	try {
		await db.dataPointTreeBoolean.bulkAdd(dataPointTree);
	} catch (error) {
		console.log(error);
	}
};
